import { TemplateRef } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Observable } from 'rxjs';

export interface IMenuEvent {
    name: string;
    data: {
        originalEvent: Event;
        menuItem: ICustomMenuItem;
        index: number;
    };
}


export interface IMenuWrapper {
    name: string;
    items: () => Observable<ICustomMenuItem[]>;
}

export interface ICustomMenuItem extends MenuItem {
    bottom?: boolean;
    order?: number;
    component?: string;
    isSeparator?: boolean;
    tooltip?: string;
    iconTemplate?: TemplateRef<any>;
    rightSideTemplate?: TemplateRef<any>;
    badgeTemplate?: TemplateRef<any>;

    iconType?: '' | 'fontawesome';
    iconSize?: string;
    labelSize?: string;
    bold?: boolean;
    items?: ICustomMenuItem[];
    badgeValue?: number;
    badgeSeverity?: 'success' | 'info' | 'warning' | 'danger';
    badgeSize?: 'normal' | 'large' | 'xlarge';
    position?: 'TOP' | 'BOTTOM';
}

export class CustomMenuItem {
    static orderMenuItems(menuItems: ICustomMenuItem[]): ICustomMenuItem[] {
        const result = menuItems.sort((a: ICustomMenuItem, b: ICustomMenuItem) => {
            return a.order < b.order
                ? -1
                : (a.order > b.order ? 1 : 0);
        });

        result.filter(item => item.items && item.items.length > 1)
            .forEach(item => item.items = this.orderMenuItems(item.items));

        return result;
    }
}

export interface IMenuItemParameters{
    menuItem: ICustomMenuItem;
    parentComponent: ISubmenuComponent;
    index: number;
}

export interface ISubmenuComponent{
    activeIndex: number;
    currentLayout$: Observable<any>;

    itemClick(event: Event, item: MenuItem, index: number): void;
    onMouseEnter(index: number): void;
}
